import type { FeedType } from '../hooks/use-store'

export const getCountriesUrl = ({ apiBaseUrl, feedType }: { apiBaseUrl: string; feedType: FeedType }) => {
	return `${apiBaseUrl}/countries?feed_type=${feedType}`
}
